import {combineReducers} from 'redux';
import contactReducer from './contactReducer';

export default combineReducers({
  contact: contactReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js